import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const lpaSecurityDataState = atom({
  key: 'lpaSecurityDataState',
  default: {
    responses: [],
    notes: [], 
    scores: [],
    capturedImages: [],
    totalScore: 100,
  },
  effects_UNSTABLE: [persistAtom],
});